// removed by extract-text-webpack-plugin
module.exports = {"job":"_2wMG5mkZ","top":"_3rhUdhbb","bottom":"_3f0Oe6l5","icon":"DnU1srDS","heading":"_2BOUlIAE","title":"_7vEh1kca","company":"_3Mo-i98V","dates":"_34pbluJD","description":"_3AakZ8pK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Job/Job.pcss
// module id = 1003
// module chunks = 0